import { AddCircleOutline } from '@mui/icons-material'
import { IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { Chip } from '@workwave-tidal/core/components'

import type { BulkTagValuePartial } from '../types'

import { useTexts } from '../hooks/useTexts'

interface Props {
  onDeleteTag: (tagName: string) => void
  onAddTag: (tagName: string) => void
  tags: BulkTagValuePartial[]
  totalSelectedItems: number
  bannedTagCategory: 'tagsIn' | 'tagsOut'
}

export function PartialList(props: Props) {
  const { tags, onDeleteTag, onAddTag, totalSelectedItems, bannedTagCategory } = props

  const texts = useTexts()

  if (tags.length === 0) return null

  return (
    <Stack spacing={2}>
      <Typography variant="body2" color="text.secondary">
        {texts.listTitle}
      </Typography>
      {tags.map(tag => {
        return (
          <Stack direction="row" spacing={1} alignItems="center" key={tag.name}>
            <Typography variant="body2" color="text.disabled">
              {tag.count}/{totalSelectedItems}
            </Typography>

            <Stack direction="row" spacing={1}>
              <Tooltip title={texts.removeTagTooltip}>
                <span>
                  <Chip
                    label={tag.name}
                    variant="outlined"
                    size="small"
                    onDelete={() => onDeleteTag(tag.name)}
                  />
                </span>
              </Tooltip>
              <Tooltip
                title={tag.warning ? texts.warningTooltip(bannedTagCategory) : texts.addTooltip}
              >
                <span>
                  <IconButton
                    color="primary"
                    onClick={() => onAddTag(tag.name)}
                    sx={{ 'padding': 0 }}
                    disabled={tag.warning}
                  >
                    <AddCircleOutline />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}
